module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "modal-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    staticClass: "modal",
    on: {
      "click": _vm.onOverlayClick
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "overlay-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    staticClass: "modal-overlay"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a8139ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 523
// module chunks = 1